import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import './preference-switches.css';

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'vi';
  return <div className={cn('preference-switch language-switch', className)} role="group" aria-label={lang === 'en' ? 'Language' : 'Ngôn ngữ'}>
    {(['vi', 'en'] as const).map((value) => <button key={value} lang={value} aria-label={value === 'vi' ? 'Tiếng Việt' : 'English'} aria-pressed={lang === value} onClick={() => void i18n.changeLanguage(value)}>{value.toUpperCase()}</button>)}
  </div>;
}
export default LanguageSwitcher;
